<template>
    <div class="home pure-g">

        <modal name="ask" style="letter-spacing: normal" :width="400" :height="150">
            <div style="width: 400px;">
                <div style="margin: 15px;">Wollen sie die Inventur wirklich löschen?</div>
                <div style="margin: 15px;">
                    <button v-on:click="okDialog()" style="margin-right: 15px;" class="dialog-button">L&ouml;schen</button>
                    <button v-on:click="cancelDialog()" class="dialog-button">Abbrechen</button>
                </div>
            </div>
        </modal>

        <MainMenu class="pure-u-1-6"/>

        <div class="pure-u-5-6">
      
            <div class="menuBarBox">
                <div id="menuBar" class="pure-menu pure-menu-horizontal menuBar">
                    <li class="pure-menu-item" ><a id="menuPlaceholder" href="#" class="pure-menu-link" to="/stocktakings/new" >I</a></li>
                    <li id="menuNewStocktaking" class="pure-menu-item" ><router-link v-if="isInRole([ 'customer_admin' ])" class="pure-menu-link" to="/stocktakings/new" >+ Neue inventur</router-link></li>                    
                </div>
            </div>

            <div class="formBox">
                <form class="pure-form pure-form-stacked">
                    <fieldset>
                        <legend>Inventuren</legend>
                        <!-- <input type="text" class="pure-input-rounded searchField" placeholder="Suchen"> -->
                    </fieldset>
                </form>
            </div>
        

            <div class="tableBox">
                <div class="pure-menu pure-menu-horizontal tableNav">
                    <li id="tableNavFirst" class="pure-menu-item"><a class="pure-menu-link" v-on:click="loadData(data._links.firstPage.href)">&lt;&lt;</a></li>
                    <li id="tableNavPrev" class="pure-menu-item"><a class="pure-menu-link" v-on:click="loadData(data._links.prevPage.href)">&lt;</a></li>
                    <li class="pure-menu-item">Seite {{ data.page + 1 }} von {{ data.pages }} &frasl; Inventuren: {{ data.total }}</li>
                    <li id="tableNavNext" class="pure-menu-item"><a class="pure-menu-link" v-on:click="loadData(data._links.nextPage.href)">&gt;</a></li>
                    <li id="tableNavLast" class="pure-menu-item"><a class="pure-menu-link" v-on:click="loadData(data._links.lastPage.href)">&gt;&gt;</a></li>
                </div>
                <table class="pure-table table">
                    <thead>
                        <tr> 
                            <th id="colName">Filiale</th>
                            <th id="colEmail">Datum</th>
                            <th style="text-align: right">F&auml;cher</th>
                            <th style="text-align: right">Erstes Fach</th>
                            <th style="text-align: right">Letztes Fach</th>
                            <th style="text-align: right">Erfassungen</th>
                            <th style="text-align: right">Erfasste Positionen</th>
                            <th class="colAction"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="stocktaking in  data.data " :key="stocktaking.date">
                            <td>{{ stocktaking.store }}</td>
                            <td>{{ new Date(stocktaking.date).toLocaleDateString('de', { month: '2-digit', day: '2-digit', year: 'numeric' } ) }}</td>
                            <td style="text-align: right">{{ stocktaking.countLocations }}</td>
                            <td style="text-align: right">{{ stocktaking.minLocationScanCode }}</td>
                            <td style="text-align: right">{{ stocktaking.maxLocationScanCode }}</td>
                            <td style="text-align: right">{{ stocktaking.countRecords }}</td>
                            <td style="text-align: right">{{ stocktaking.countRecordItems }}</td>
                            <td style="width: 100px;">
                                <a v-on:click="editStocktaking(stocktaking)"><pencil-icon fillColor="#444444"/></a>
                                <a v-on:click="deleteStocktaking(stocktaking)"><delete-icon fillColor="#ff4d4d"/></a>
                                <a v-bind:href="getDownloadExcelUrl(stocktaking)"><download-icon fillColor="#444444"/></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>    
</template>


<script>
import MainMenu from '@/components/MainMenu.vue'
import { getJwt, hasRole } from "@/utils/auth.js"
import PencilIcon from "vue-material-design-icons/pencil.vue"
import DeleteIcon from "vue-material-design-icons/delete.vue"
import DownloadIcon from "vue-material-design-icons/download"
import { getApiUrl } from '@/utils/api.js'
import axios from "axios"
import router from "@/router.js"

export default {
    name: 'StocktakingView',
    components: {
        MainMenu,
        PencilIcon,
        DeleteIcon,
        DownloadIcon
    },
    data: function() {
        return {
            data: {
                data: []
            },
            selectedStocktaking: null,
            url: null
        }
    },
    mounted: function() {

        this.loadData(getApiUrl() + '/v0/stocktakings')
    },
    methods: {

        loadData: function(url) {

            this.url = url

            axios({
                method: "GET",
                url: url,
                headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + getJwt()
                }
            }).then(
                result => {
                    this.data = result.data;
                },
                error => {
                    console.error(error.response.data.status)
                }
            )
        },

        editStocktaking: function(stocktaking) {

            router.push({
                name: "editStocktakingView",
                params: {
                    url: stocktaking._links.self.href
                }
            });
        },

        deleteStocktaking: function(stocktaking) {

            this.selectedStocktaking = stocktaking
            this.$modal.show('ask')
        },

        cancelDialog: function() {

            this.$modal.hide('ask')
        },

        okDialog: function() {

            console.info(this.selectedStocktaking._links.self.href)

            axios({
                method: "delete",
                url: this.selectedStocktaking._links.self.href,
                data: null,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + getJwt()
                }
            }).then(
                result => {

                    this.loadData(this.url)
                    this.$modal.hide('ask')
                },
                error => {
                    console.error(error.response.data.status)
                    this.$modal.hide('ask')
                }
            )
        },

        isInRole: function(roles) {

          return hasRole(roles)
        },

        getDownloadExcelUrl: function(stocktaking) {

            return stocktaking._links.self.href + '/csv'
        }
    }
}
</script>

<style>

#menuPlaceholder {
    color: white;
}
</style>


